import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "constants";

// Define the summary-related API endpoints
export const summaryApi = createApi({
  reducerPath: "summaryApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
  }),
  tagTypes: ["Summary"],
  endpoints: (builder) => ({
    getSummary: builder.query({
      query: ({ projectId }) => ({
        url: `project/${projectId}/summary/json`,
        // responseHandler: (response) => response.text(),
      }),
    }),
  }),
});

export const { useGetSummaryQuery } = summaryApi;
export default summaryApi;
